import { Component, Input, Output, EventEmitter, OnDestroy, signal, computed, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

type EventType = 'critique' | 'info' | 'retablissement' | 'surveillance' | 'degrade' | 'discussion';

interface Evenement {
  id: number;
  type: EventType;
  offsetMin: number;
  message: string;
  badge: string;
  site: string;
}

@Component({
  selector: 'app-actus-screen',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './actus-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./actus-screen.component.scss'],
})
export class ActusScreenComponent implements OnDestroy {
  @Input() filterSites: string[] = [];
  @Output() openFilter = new EventEmitter<void>();

  private readonly _now = signal(new Date());
  private readonly _timer = setInterval(() => this._now.set(new Date()), 60_000);

  readonly evenements: Evenement[] = [
    { id:  1, type: 'discussion',    offsetMin: 0,  message: 'Discussion "Nantes Centre · coordination urgence" ouverte — 6 membres',  badge: 'DISCUSSION',     site: 'Nantes Centre'   },
    { id:  2, type: 'info',          offsetMin: 2,  message: 'Alerte envoyée — Carquefou dépasse capacité, 3 sites notifiés',           badge: 'ALERTE',         site: 'Carquefou'       },
    { id:  3, type: 'degrade',       offsetMin: 5,  message: 'Mode dégradé activé — Saint-Herblain, protocole flux allégé en cours',   badge: 'MODE DÉGRADÉ',   site: 'Saint-Herblain'  },
    { id:  4, type: 'surveillance',  offsetMin: 8,  message: 'Temps d\'attente Rezé : 45 min → 28 min après renfort',                  badge: 'ATTENTE',        site: 'Rezé'            },
    { id:  5, type: 'critique',      offsetMin: 12, message: 'Nantes Centre critique depuis 21 min — charge à 130 %',                  badge: 'CRITIQUE',       site: 'Nantes Centre'   },
    { id:  6, type: 'info',          offsetMin: 15, message: 'Alerte renforts envoyée — Orvault, Rezé et Vertou disponibles notifiés', badge: 'ALERTE',         site: 'Réseau'          },
    { id:  7, type: 'surveillance',  offsetMin: 20, message: 'Carquefou - Ajustement manuel temps attente : +15 min',                  badge: 'ATTENTE',        site: 'Carquefou'       },
    { id:  8, type: 'discussion',    offsetMin: 25, message: 'Discussion "Coordination réseau 16h" ouverte — 9 membres',               badge: 'DISCUSSION',     site: 'Réseau'          },
    { id:  9, type: 'degrade',       offsetMin: 32, message: 'Mode dégradé désactivé — Orvault, retour au protocole standard',        badge: 'MODE DÉGRADÉ',   site: 'Orvault'         },
    { id: 10, type: 'retablissement',offsetMin: 42, message: 'Rezé redevenu fluide après renfort de Marie L.',                        badge: 'RÉTABLISSEMENT', site: 'Rezé'            },
    { id: 11, type: 'retablissement',offsetMin: 55, message: 'Orvault redevenu fluide',                                               badge: 'RÉTABLISSEMENT', site: 'Orvault'         },
  ];

  get filteredEvenements(): Evenement[] {
    if (this.filterSites.length === 0) return this.evenements;
    return this.evenements.filter(e => this.filterSites.includes(e.site));
  }

  timeOf(offsetMin: number): string {
    const d = new Date(this._now().getTime() - offsetMin * 60_000);
    return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  }

  ngOnDestroy(): void {
    clearInterval(this._timer);
  }
}